import { motion } from "framer-motion";
import { IMAGES } from "../lib/site";

const TILES = [
  { key: "construction", label: "Infrastructure", tag: "Built Environment", span: "md:col-span-7 md:row-span-2", h: "h-[360px] md:h-[620px]" },
  { key: "office", label: "Boardrooms", tag: "Strategic Counsel", span: "md:col-span-5", h: "h-[360px] md:h-[300px]" },
  { key: "facade", label: "Modern Enterprise", tag: "High-End Business", span: "md:col-span-5", h: "h-[360px] md:h-[300px]" },
];

const Tile = ({ tile }) => (
  <motion.figure
    data-testid={`portfolio-${tile.key}`}
    initial={{ opacity: 0, scale: 0.96 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
    className={`group relative overflow-hidden border border-gold/20 ${tile.span}`}
  >
    <img
      src={IMAGES[tile.key]}
      alt={tile.label}
      className={`w-full object-cover grayscale-[0.15] transition-all duration-[1.2s] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-110 group-hover:grayscale-0 ${tile.h}`}
    />
    <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/10 to-transparent" />
    <div className="absolute inset-0 bg-gold/0 transition-colors duration-700 group-hover:bg-gold/5" />
    <figcaption className="absolute bottom-0 left-0 p-8">
      <span className="mb-2 block font-body text-[10px] uppercase tracking-[0.3em] text-gold">
        {tile.tag}
      </span>
      <span className="font-display text-3xl font-light text-cream md:text-4xl">
        {tile.label}
      </span>
    </figcaption>
  </motion.figure>
);

export const Gallery = () => {
  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="relative border-t border-gold/20 bg-eggshell-800 py-32 md:py-44"
    >
      <div className="mx-auto max-w-[1500px] px-8 md:px-16">
        <div className="mb-16 max-w-2xl">
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="mb-4 font-body text-xs uppercase tracking-[0.4em] text-gold"
          >
            The Portfolio
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="font-display text-4xl font-light leading-tight text-ink md:text-6xl"
          >
            Where capital, craft, and
            <span className="italic text-gold"> contracts</span> converge.
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 gap-5 md:auto-rows-min md:grid-cols-12">
          {TILES.map((t) => (
            <Tile key={t.key} tile={t} />
          ))}
        </div>
      </div>
    </section>
  );
};
